<ion-header color="Primary">
    <ion-toolbar color="whitesmoke">
        <ion-buttons slot="start">
            <ion-button (click)="cancelChanges()">
                <ion-icon name="close-circle-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{ titleKey | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="confirmChanges()"
                        [disabled]="maxSelectedItems && selectedItems.length > maxSelectedItems">
                <ion-icon name="checkmark-circle-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
    <div class="selectionButtons">
        <ion-buttons>
            @if (maxSelectedItems && filteredItems.length <= maxSelectedItems) {
                <ion-button
                    (click)="selectAllItems()">{{ "components.form.searchableSelect.buttons.selectAll" | translate }}
                </ion-button>
            }
            <ion-button
                (click)="deselectAllItems()">{{ "components.form.searchableSelect.buttons.deselectAll" | translate }}
            </ion-button>
        </ion-buttons>
    </div>
    <ion-toolbar color="whitesmoke">
        <ion-searchbar (ionInput)="searchbarInput($event)" [debounce]="750"
                       placeholder="{{'components.form.searchableSelect.search' | translate}}"></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" color="light">
    @if (maxSelectedItems && selectedItems.length > maxSelectedItems) {
        <div class="maxSelectedItemsWarning selectionWarning">
            <ion-icon size="medium" name="alert-circle-outline"></ion-icon>
            <p>{{ ("components.form.searchableSelect.maxSelectedItemsMessage." + (maxSelectedItems > 1 ? "multiple" : "single")) | translate:{maxSelectedItems} }}</p>
        </div>
    } @else if (maxSelectedItems && warningThreshold && amountOfItemsBeforeExceedingLimit >= 0 && amountOfItemsBeforeExceedingLimit <= warningThreshold) {
        <div class="limitWarning selectionWarning">
            <ion-icon size="medium" name="warning-outline"></ion-icon>
            @if (amountOfItemsBeforeExceedingLimit > 1) {
                <p>{{ "components.form.searchableSelect.limitWarningMessage.multiple" | translate:{amountOfItemsBeforeExceedingLimit} }}</p>
            } @else if (amountOfItemsBeforeExceedingLimit == 1) {
                <p>{{ "components.form.searchableSelect.limitWarningMessage.single" | translate }}</p>
            } @else {
                <p>{{ "components.form.searchableSelect.limitWarningMessage.none" | translate:{maxSelectedItems} }}</p>
            }
        </div>
    }

    <ion-list [inset]="true">
        @if (filteredItems.length > 0) {
            @for (item of filteredItems; track item[this.trackProperty]) {
                <ion-item>
                    <ion-checkbox [value]="item" [checked]="isChecked(item)" (ionChange)="checkboxChange($event)">
                        {{ item[this.searchableProperty] ?? (this.fallbackSearchableProperty ? item[this.fallbackSearchableProperty] : "") }}
                    </ion-checkbox>
                </ion-item>
            }
        } @else {
            <p class="ion-padding-start">{{ "components.form.searchableSelect.noContentMessage" | translate }}</p>
        }
    </ion-list>
</ion-content>
